import yup from '../index'

export const gender = ['FEMALE', 'MALE'] as const
export type Gender = typeof gender[number]

export const genderSchema = yup.string().oneOf(gender)
